import makeVueModal from '@/views/modal/make_vue_modal';
import track from '@/helpers/track';

let modal = null;

$(document).on('turbolinks:before-cache', () => {
  if (modal) {
    modal.destroy();
    modal = null;
  }
});

pageLoad('pages_root', async () => {
  if (!document.body.className.includes('v4')) { return; }

  $('article.slide_11 button.lead').one('click', async ({ currentTarget }) => {
    const $node = $(currentTarget);

    modal ||= makeVueModal({
      trigger: currentTarget,
      vue: {
        importComponent: async () => await import('@/vue/modals/call_lead'),
        props: {
          submitUrl: $node.data('submit_url'),
          leadType: $node.data('leadType'),
          trackEvent: $node.data('trackEvent'),
          trackEventLocation: $node.data('trackEventLocation'),
          privacyUrl: $node.data('privacy_url'),
          faqUrl: $node.data('faq_url'),
          graphqlUrl: $node.data('graphql_url')
        }

      },
      isCloseOnSubmit: true,
      onShow: () => {
        const { trackEventLocation } = $(currentTarget).data();
        track({ event: 'callback_form_opened', form_location: trackEventLocation });
      }
    });
    modal.show();
  });
});
